<div 
  [formGroup]="form"
  class="reg-input"
  [ngClass]="{'enhanveOnHover': enhanveOnHover}"
  cdkOverlayOrigin #trigger="cdkOverlayOrigin"
  id="div-{{inputId}}">
  <input
    [value]="defaultValue"
    type="text"
    [id]="inputId"
    name="autocomplete"
    class="reg-input-control"
    [placeholder]="placeholder"
    autocomplete="off"
    formControlName="searchInput"
    (input)="searchAutocomplete(form.value['searchInput'])"
    (keydown.enter)="selectAutocomplete()"
    (keydown)="downList($event)"
    [maxLength]="maxLength">
  <button class="btn-search" *ngIf="loading">
    <lib-loading class="loading" ></lib-loading>
  </button>
  <button class="btn-search" (click)="searchProduct()" *ngIf="showSearch && !loading">
    <img src="../../../../assets/svgs/search.svg" alt="Buscar">
  </button>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="autocomp && autoSearchResults.length > 0">
    <div class="reg-input-autocomplete">
      <div
        id="autocomplete-result-{{i}}"
        class="autocomplete-item"
        [ngClass]="{'keyHover': i === autocompIdx}"
        (pointerover)="pointerSelection(i)"
        (click)="patchInputValue(i)"
        *ngFor="let result of autoSearchResults; let i = index">
        <span class="select-description" [innerHTML]=result[value]></span>
        <div class="badge" *ngIf="!onlyDescription">
          <span *ngIf="result.labelDescription" class="select-type" [innerHTML]=result.labelDescription></span>
          <span *ngIf="result.type" class="select-type" [innerHTML]=result.type></span>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="backdrop" *ngIf="autocomp" (click)="closeDropdown()"></div>
  <span (click)="resetValue()" *ngIf="isMkt" id="resetAutocompleteButton2"></span>
</div>
